import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const FeePage = lazy(() => import("./web/FeesPage.js").then((m) => ({ default: m.FeePage })));
const FeesPage = lazy(() => import("./web/FeesPage.js").then((m) => ({ default: m.FeesPage })));
const OperatorsPage = lazy(() => import("./web/OperatorsPage.js").then((m) => ({ default: m.OperatorsPage })));

export default defineWebModule({ manifest, pages: { "": OperatorsPage, "/fees": FeesPage, "/fees/week": FeePage } });
